var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "frankinForm__saveProgress saveProgress saveProgress--full saveProgress--paddingLarge",
      staticStyle: { "margin-top": "0" }
    },
    [
      _c("section", { staticClass: "formIntro" }, [
        _c("div", { staticClass: "in container" }, [
          _c("h4", [_vm._v("Let’s get started!")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "You are just a few minutes away from your franking machine quote."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "We search and compare all manufacturer models in the market place e.g. Pitney Bowes, Quadient (Neopost), FP and Frama. No need to speak to salespeople and filter out what is actually best for your business, we provide the facts with a full savings and return on investment calculation."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Its important you answer all questions to the best of your ability, the detail entered will be used to calculate your savings, return on investment summary and provide you with a choice of suitable solutions from each manufacturer relevant to your specific business requirements."
            )
          ]),
          _vm._v(" "),
          _vm.currentStep > 1
            ? _c(
                "a",
                {
                  staticClass: "btn btn--base",
                  attrs: { href: "#", tabindex: "0" },
                  on: { click: _vm.stepBack }
                },
                [_vm._v("Go Back")]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "in container" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "saveProgress__form" }, [
          _c(
            "div",
            {
              staticClass: "saveProgress__inputBlock",
              class: {
                "inputPanel__error lead_error":
                  _vm.invalidLeadFields.company_name
              }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.company_name,
                    expression: "company_name"
                  }
                ],
                staticClass: "inputLarge",
                attrs: {
                  type: "text",
                  id: "over2CompanyName",
                  placeholder: "Company Name"
                },
                domProps: { value: _vm.company_name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.company_name = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _vm.invalidLeadFields.company_name
                ? _c("div", { staticClass: "errorMsg" }, [
                    _c("span", [
                      _vm._v(
                        "Please enter your company name above and click Save"
                      )
                    ])
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "saveProgress__inputBlock",
              class: {
                "inputPanel__error lead_error": _vm.invalidLeadFields.name
              }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.name,
                    expression: "name"
                  }
                ],
                staticClass: "inputLarge",
                attrs: { type: "text", id: "over2Name", placeholder: "Name" },
                domProps: { value: _vm.name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.name = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _vm.invalidLeadFields.name
                ? _c("div", { staticClass: "errorMsg" }, [
                    _c("span", [
                      _vm._v("Please enter your name above and click Save")
                    ])
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "saveProgress__inputBlock",
              class: {
                "inputPanel__error lead_error":
                  _vm.invalidLeadFields.contact_phone
              }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.phone,
                    expression: "phone"
                  }
                ],
                staticClass: "inputLarge",
                attrs: {
                  type: "text",
                  id: "over2Phone",
                  placeholder: "Contact Telephone Number"
                },
                domProps: { value: _vm.phone },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.phone = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _vm.invalidLeadFields.contact_phone
                ? _c("div", { staticClass: "errorMsg" }, [
                    _vm.phone && _vm.phone.length < 11
                      ? _c("span", [_vm._v("The number is to short.")])
                      : _vm.phone && _vm.phone.length > 11
                      ? _c("span", [
                          _vm._v(
                            "The number should accept only 11 digit numbers (no spaces)."
                          )
                        ])
                      : _c("span", [
                          _vm._v(
                            "Please enter a valid phone number and click Save."
                          )
                        ])
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "saveProgress__inputBlock",
              class: {
                "inputPanel__error lead_error": _vm.invalidLeadFields.email
              }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.email,
                    expression: "email"
                  }
                ],
                staticClass: "inputLarge",
                attrs: {
                  type: "email",
                  id: "over2Email",
                  placeholder: "Email"
                },
                domProps: { value: _vm.email },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.email = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _vm.invalidLeadFields.email
                ? _c("div", { staticClass: "errorMsg" }, [
                    _c("span", [
                      _vm._v("Please enter a valid email above and click Save")
                    ])
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "saveProgress__inputBlock",
              class: {
                "inputPanel__error lead_error":
                  _vm.invalidLeadFields.contact_time
              }
            },
            [
              _c("datetime", {
                ref: "datetime",
                attrs: { format: "yyyy-LL-dd HH:mm:ss", type: "datetime" },
                model: {
                  value: _vm.contact_time,
                  callback: function($$v) {
                    _vm.contact_time = $$v
                  },
                  expression: "contact_time"
                }
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.contact_time_show,
                    expression: "contact_time_show"
                  }
                ],
                staticClass: "inputLarge",
                attrs: {
                  type: "text",
                  autocomplete: "off",
                  readonly: true,
                  placeholder: "Date & Time",
                  id: "over2time"
                },
                domProps: { value: _vm.contact_time_show },
                on: {
                  click: _vm.clickDatetime,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.contact_time_show = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _vm.invalidLeadFields.contact_time
                ? _c("div", { staticClass: "errorMsg" }, [
                    _c("span", [
                      _vm._v("Please enter date & time above and click Save")
                    ])
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("input", {
            attrs: { id: "saveOver2Submit", type: "submit", value: "save" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.onSubmit($event)
              }
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "saveProgress__content" }, [
      _c("h4", [
        _vm._v(
          "Click here to confirm your details and schedule a time for a call back to discuss"
        )
      ]),
      _vm._v(" "),
      _c("p", { attrs: { id: "em" } }, [
        _vm._v(
          "We are appointing a dedicated support agent to review the market for you, this is to help you through the process and to achieve the best technology at the best rate."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ce9b3b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ce9b3b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Quotes/Form/Step-1/Conditionals/Form_MachinesAmountOver10.vue
// module id = null
// module chunks = 